import * as React from "react";
import { WithStyles, withStyles } from "@material-ui/styles";
import { Box, Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import messages from "../constants/messages";
import { styles } from "../constants/styles";
import { useHistory } from "react-router";
import { useEffect, useState } from "react";
import { Link } from "../../../../navigation";
import { useAuth } from "../../../shared/hooks/useAuth";

type Props = WithStyles<typeof styles>;

const SuccessPasswordChangePage: React.FC<Props> = (props: Props) => {
  const [time, setTime] = useState(10);
  const [, , , logout] = useAuth();
  const history = useHistory();
  useEffect(() => {
    localStorage.removeItem("isPasswordExpired");
    if (time) {
      setTimeout(() => setTime((prev) => prev - 1), 1000);
    } else {
      history.push("/login");
      logout();
    }
  }, [time]);
  const baseUrl = location.origin;
  const { classes } = props;
  const onClick = ()=>{
    logout();
  } 
  return (
    <>
      <div className={classes.root}>
        <Box className={classes.box}>
          <Typography className={classes.header}>
            <FormattedMessage {...messages.headerActivated} />
          </Typography>
          <Typography className={classes.passwordLengthHint}>
            <FormattedMessage {...messages.redirectHint} values={{ time: time }} />
          </Typography>
          <Typography className={classes.passwordLengthHint}>
            <FormattedMessage {...messages.followLinkHint} /> <Link onClick={onClick} to="/login">{baseUrl}</Link>
          </Typography>
        </Box>
      </div>
    </>
  );
};

export default withStyles(styles)(SuccessPasswordChangePage);
